import React, { useEffect, useState } from 'react'
import './helpdesk.css'
import { Button, Form, Input } from 'antd';
import { useSelector } from 'react-redux';
import { useCookies } from 'react-cookie'
import { notification } from 'antd';
import key from '../../key';
import axios from 'axios';
import { AiFillDelete } from 'react-icons/ai';

const HelpDesk = () => {
    const { user } = useSelector(state => state.user)
    const [form] = Form.useForm();
    const [queries, setQueries] = useState([])
    //eslint-disable-next-line
    const [cookies, setCookies, removeCookies] = useCookies(['x-auth-token']);

    const onFinish = async (values) => {
        let data = { query: values.query }
        try {
            const response = await axios.post(`${key}/api/help/create-help`, data, {
                headers: {
                    "x-auth-token": cookies['x-auth-token'],
                },
            });
            if (response.data.success === true) {
                notification.success({ message: "Your Query has been submitted. We will get back to you as soon as possible. Thank You!" });
                form.resetFields();
            } else {
                notification.error({ message: "Something went wrong!" });
            }
        } catch (error) {
            notification.error({ message: "Something went wrong!" });
        }
    };
    useEffect(() => {
        const getQueries = async () => {
            try {
                const response = await axios.get(`${key}/api/help/get-help`, {
                    headers: {
                        "x-auth-token": cookies['x-auth-token'],
                    },
                });
                setQueries(response.data.help)
            } catch (error) {
                notification.error({ message: "Something went wrong!" });
            }
        }
        getQueries()
//eslint-disable-next-line
    }, [queries])

    const handelDelete = async (id) => {
        try {
            const response = await axios.delete(`${key}/api/help/delete-help/${id}`, {
                headers: {
                    "x-auth-token": cookies['x-auth-token'],
                },
            });
            if (response.data.success === true) {
                queries.filter((query) => query._id !== id)
                notification.success({ message: "Your Query has been deleted!" });
            } else {
                notification.error({ message: "Something went wrong!" });
            }
        } catch (error) {
            notification.error({ message: "Something went wrong!" });
        }
    }
    return (
        <div className='container helpDesk'>
            <div className='head'>Welcome to Help Desk of <span className='span'>Lovodi.com</span></div>
            <div className='backgroundLight'>
                <div className='subHead'>
                    <div className='d1'> Hi! <span> {user.firstName} {user.lastName}</span>, What's in your Mind!!</div>
                    <div className='d2'>We are here to help you. Please write your query below. We will get back to you as soon as possible.</div>
                    <div className='d3'>Thank You!</div>
                </div>
                <div className="d-flex justify-content-center">
                    <Form
                        form={form}
                        name="basic"
                        onFinish={onFinish}
                    >
                        <Form.Item
                            label="Query"
                            name="query"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your Query!',
                                },
                            ]}
                        >
                            <Input.TextArea style={{ width: 600 }} rows={4} />
                        </Form.Item>
                        <Form.Item
                            wrapperCol={{
                                offset: 8,
                                span: 16,
                            }}
                        >
                            <Button type="primary" htmlType="submit">
                                Submit Your Query
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </div>
            <div className='mt-3'>
                <div className='head'>Here are your <span className='span'>Queries</span></div>
                <div className='backgroundLight'>
                    <div className='row tableHeading'>
                        <div className='col-md-1'>
                            Sr. No.
                        </div>
                        <div className='col-md-7'>
                            Query
                        </div>
                        <div className='col-md-2 cs_date'>
                            Date <span>(dd/mm/yyyy)</span>
                        </div>
                        <div className='col-md-2'>
                            Status
                        </div>
                    </div>
                </div>
                {queries.map((query, index) => (
                    <div className='backgroundLight' key={index}>
                        <div className='row tableData'>
                            <div className='col-md-1'>
                                {index + 1}
                            </div>
                            <div className='col-md-7'>
                                {query.query}
                            </div>
                            <div className='col-md-2'>
                                {query.date}
                            </div>
                            <div className='col-md-2 d-flex justify-content-between'>
                                <span className={`customBadge bg-${query.status === "pending" ? "warning" : "success"}`}>{query.status}</span>
                                <div style={{ cursor: "pointer" }} onClick={() => handelDelete(query._id)}><AiFillDelete size={20} /></div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            <div className='mt-3'>.</div>
        </div>
    )
}

export default HelpDesk
